import {
  aboutUs,
  allCustomerReviews,
  backmarketWarranty,
  boMerchant,
  buyBack,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  giftFinder,
  help,
  hireExternal,
  insurances,
  legal,
  modelsComparison,
  referFriend,
  studentGoodDeals,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const jpConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [
        aboutUs,
        {
          translationKey: 'impact',
          href: '/ja-jp/about-us#scroll=false&target=heading-2-back-market\u306E\u30A4\u30F3\u30D1\u30AF\u30C8\u30FB\u30EC\u30DD\u30FC\u30C8',
        },
        {
          translationKey: 'press',
          href: '/ja-jp/about-us#scroll=false&target=heading-2-\u30D7\u30EC\u30B9\u30AD\u30C3\u30C8',
        },
        hireExternal,
      ],
      socials: [
        {
          name: 'instagram',
          href: 'https://www.instagram.com/backmarket_jp',
        },
        {
          name: 'youtube',
          href: 'https://www.youtube.com/@backmarket_jp',
        },
        {
          name: 'facebook',
          href: 'https://www.facebook.com/backmarketjapan',
        },
        { name: 'x', href: 'https://x.com/Backmarket_JP' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        help,
        {
          translationKey: 'contactUs',
          href: 'https://help.backmarket.com/hc/ja/articles/360026654654-Back-Market\u30AB\u30B9\u30BF\u30DE\u30FC\u30B1\u30A2\u306B\u9023\u7D61\u3059\u308B\u306B\u306F',
        },
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/ja/articles/360033250174',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/ja/categories/28782686975644-%E8%BF%94%E5%93%81-%E8%BF%94%E9%87%91',
        },
        buyingGuides,
        giftFinder,
        modelsComparison,
        allCustomerReviews,
        {
          translationKey: 'payment',
          href: 'https://help.backmarket.com/hc/ja/articles/360026643854',
        },
        { translationKey: 'paymentMethods', href: '' },
      ],
    },
    {
      titleKey: 'categoryServices',
      links: [
        referFriend,
        backmarketWarranty,
        insurances,
        buyBack,
        studentGoodDeals,
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.co.jp/ja-jp/seller/home',
        },
        boMerchant,
      ],
    },
    {
      titleKey: 'categoryLaw',
      links: [termsUse, dataProtection, cookiePolicy, legal],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
